import {
  type LinearProgressProps,
  LinearProgress as MuiLinearProgress,
} from '@mui/material';

export const LinearProgress = (props: LinearProgressProps) => (
  <MuiLinearProgress {...props} />
);
